import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import "./404NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="notfound-container">
      <div className="notfound-image">404</div>
      <h1 className="notfound-title">Page Not Found</h1>
      <p className="notfound-message">
        Sorry, the page you are looking for does not exist.
      </p>
      <div className="notfound-buttons">
        <Button
          label="Go Home"
          icon="pi pi-home"
          onClick={goHome}
          className="p-button-primary"
        />
      </div>
    </div>
  );
};

export default NotFound;
